export const errorMessages = {
  name: {
    required: 'Preencha o nome e sobrenome do usuário',
    max: 'O nome é muito longo, máximo de 100 caracteres',
  },
  email: {
    invalid: 'Preencha o e-mail corretamente',
    required: 'O e-mail é obrigatório',
  },
  userMartins: {
    required: 'Preencha o usuário de rede corretamente',
  },
  roleId: {
    required: 'A função do usuário é necessária',
  },
  advertisingId: {
    required: 'Selecione um anunciante',
  },
  cpf: {
    required: 'Informe o CPF',
    invalid: 'CPF deve ter 11 dígitos',
  },
};
